import React from 'react';
import Helmet from 'react-helmet';
import { AsyncCss } from '../../components/async-css';
import { Footer } from '../../components/footer';
import { Navigation } from '../../components/navigation';

import './index.scss';

export class Parent extends React.Component {
  get slugs () {
    return {
      slug: this.props.page.slug,
      nlSlug: this.props.page.nlSlug,
      frSlug: this.props.page.frSlug,
      enSlug: this.props.page.enSlug
    }
  }

  render () {
    return (
      <React.Fragment>
        <Helmet>
          <link rel="icon" type="image/png" href="favicon-32x32.png" sizes="32x32" />
          <link rel="icon" type="image/png" href="favicon-16x16.png" sizes="16x16" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="628" />
          <meta name="p:domain_verify" content="731772ef04a65d2591f3e944af6479fc" />
        </Helmet>
        <Navigation language={this.props.language} {...this.props.navigation} slugs={this.slugs} />
        <main className="content">{ this.props.children }</main>
        { /* <CookieBanner {...this.props} /> */ }
        <Footer partnersInFooter={this.props.page.festival.partnersInFooter || []} />
        <AsyncCss href="https://fonts.googleapis.com/css?family=Nunito+Sans:400,600,700,900" />
        <AsyncCss href="https://fonts.googleapis.com/css?family=Work+Sans" />
        <AsyncCss href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" /> 
        <AsyncCss href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
      </React.Fragment>
    );
  }
}